export default __webpack_public_path__ + "static/char-s-01-chs-9b64ead5027c6f1a10d7e204f7aad74d.png";